// import {TweenMax} from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';


var controller = new ScrollMagic.Controller();

var scene_hero = new ScrollMagic.Scene({
  triggerElement: "body",
  triggerHook: 'onEnter',
  // duration: 800,
  offset: 0
})
  // .addIndicators()
  .addTo(controller);

scene_hero.on('enter', () => {
  //triggerElementを過ぎたとき
});
scene_hero.on('leave', () => {
  //triggerElementを抜けたとき
});


var scene_footer = new ScrollMagic.Scene({
  triggerElement: ".l-footer",
  triggerHook: 'onEnter',
  // duration: 800,
  offset: 0
})
  // .addIndicators()
  .addTo(controller);

scene_footer.on('enter', () => {
  $('.c-mail-box').addClass('screen-in-fotter');
});
scene_footer.on('leave', () => {
  $('.c-mail-box').removeClass('screen-in-fotter');
});


var sectionTitle = $('.c-section-title').length;
// console.log(sectionTitle);
for (var i = 0; i < sectionTitle; i++) {
  $('.c-section-title').eq(i).addClass('is-title-' + (i + 1));

  // var scene_section_title = new ScrollMagic.Scene({
  //   triggerElement: ".is-title-"+(i+1),
  //   triggerHook: 'onCenter',
  //   // duration: 800,
  //   offset: 0
  // })
  //   // .addIndicators()
  //   .addTo(controller);
  // scene_section_title.on('enter', () => {
  //   $('.is-title-'+(i+1)).addClass('is-active');
  // });
}
if ($('.is-title-1').length) {
  var scene_section_title_1 = new ScrollMagic.Scene({
    triggerElement: ".is-title-1",
    triggerHook: 'onEnter',
    // duration: 800,
    offset: 100
  })
    // .addIndicators()
    .addTo(controller);
  scene_section_title_1.on('enter', () => {
    $('.is-title-1').addClass('is-active');
  });
}
if ($('.is-title-2').length) {
  var scene_section_title_2 = new ScrollMagic.Scene({
    triggerElement: ".is-title-2",
    triggerHook: 'onEnter',
    // duration: 800,
    offset: 100
  })
    // .addIndicators()
    .addTo(controller);
  scene_section_title_2.on('enter', () => {
    $('.is-title-2').addClass('is-active');
  });
}
if ($('.is-title-3').length) {
  var scene_section_title_3 = new ScrollMagic.Scene({
    triggerElement: ".is-title-3",
    triggerHook: 'onEnter',
    // duration: 800,
    offset: 100
  })
    // .addIndicators()
    .addTo(controller);
  scene_section_title_3.on('enter', () => {
    $('.is-title-3').addClass('is-active');
  });
}
if ($('.is-title-4').length) {
  var scene_section_title_4 = new ScrollMagic.Scene({
    triggerElement: ".is-title-4",
    triggerHook: 'onEnter',
    // duration: 800,
    offset: 100
  })
    // .addIndicators()
    .addTo(controller);
  scene_section_title_4.on('enter', () => {
    $('.is-title-4').addClass('is-active');
  });
}
if ($('.is-title-5').length) {
  var scene_section_title_5 = new ScrollMagic.Scene({
    triggerElement: ".is-title-5",
    triggerHook: 'onEnter',
    // duration: 800,
    offset: 100
  })
    // .addIndicators()
    .addTo(controller);
  scene_section_title_5.on('enter', () => {
    $('.is-title-5').addClass('is-active');
  });
}
